import { helpers } from 'vuelidate/lib/validators';

export const fileSize = max => {
  return helpers.withParams({ type: 'fileSize', max }, value => {
    if (!value?.size) return true;
    const fileSize = +(value.size / (1024 * 1024)).toFixed(0);
    const maxSize = +((max * (1024 * 1024)) / (1024 * 1024)).toFixed(0);
    return fileSize <= maxSize;
  });
};

export const fileType = allowed => {
  return helpers.withParams({ type: 'fileSize', allowed }, value => {
    if (!value) return true;
    return allowed.includes(
      value.name
        .split('.')
        .pop()
        .toLowerCase()
    );
  });
};
